import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: '_easy_maths'
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(1, 6)
        let b = random.intBetween(1, 6)
        q.addJSCode(a + ' + ' + b)
        q.addBadChoices([a, b, a + b + 1])
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(1, 4)
        let b = random.intBetween(2, 4)
        q.addJSCode(a + ' * ' + b)
        q.addBadChoices([a, b + 1, a + b + 1, a + b])
    }
})


export default level

